module.exports = __webpack_public_path__ + "img/list.fe6b559b.svg";